<div class="formContainer" [ngClass]="{hasLoader: isLoading}">
  <ul *ngIf="!error; else errorMsg">
    <div [ngSwitch]="selectedForm">
      <div *ngSwitchCase="getPaidForms.PERSONAL_INFORMATION">
        <vc-personal-information
          [userIsB2C]="userIsB2C"
          [isWebView]="isWebView"
          (customerCreated)="onCustomerCreated($event)"
        ></vc-personal-information>
      </div>
      <div *ngSwitchCase="getPaidForms.TRANSFERT_METHOD">
        <div id="TransferMethodUI" class="transfer-method-ui"></div>
      </div>
      <div *ngSwitchCase="getPaidForms.VERIFICATION">
        <div id="VerificationUI" class="verification-ui"></div>
      </div>
    </div>
  </ul>
  <ng-template #errorMsg>
    <vc-get-paid-error></vc-get-paid-error>
  </ng-template>
</div>
